import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";

// Jun 2026 money-accuracy repair — the backend is the ONLY source of payment
// amounts, timing and authorization wording. Never recompute either here.

export const apptTzLabel = () => {
  try {
    return new Intl.DateTimeFormat(undefined, { timeZoneName: "short" })
      .formatToParts(new Date()).find((p) => p.type === "timeZoneName")?.value || "local time";
  } catch { return "local time"; }
};

// The customer's IANA zone (e.g. "America/New_York"). The backend CONVERTS the
// appointment into this zone before writing the authorization sentence, so the
// card, the sentence and the stored booking all describe the same moment.
export const apptTzId = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch { return "UTC"; }
};

export const money = (cents) => `$${((Number(cents) || 0) / 100).toFixed(2)}`;

/**
 * @param mode "booking" (Service Detail) | "cart"
 * @param items [{ service_id, scheduled_at, appointment_tz }]
 */
export function useCheckoutQuote({ mode, items, promoCode, authHeader, enabled = true, refreshKey = 0 }) {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const signature = JSON.stringify({ mode, items, promoCode, enabled, refreshKey });

  useEffect(() => {
    if (!enabled || !items || items.length === 0) { setQuote(null); return; }
    let alive = true;
    setLoading(true);
    (async () => {
      try {
        const r = await axios.post(`${API}/checkout/quote`,
          { mode, items, promo_code: promoCode || null },
          { headers: authHeader ? authHeader() : {} });
        if (alive) setQuote(r.data);
      } catch {
        if (alive) setQuote(null);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature]);

  return { quote, loading };
}

// Identity of what the customer is authorizing. Any change to the amounts, the
// timing or the appointment clears their tick box.
export const consentSignature = (qi) =>
  qi ? [qi.service_id, qi.scheduled_at, qi.total_today_cents, qi.remaining_balance_cents,
        qi.wording_variant, qi.consent_version].join("|") : "";
